<div class="dialog-container">
  <pub-result-view-wrapper [conceptId]="conceptId" [termId]="termId" [configId]="configId"
                           (conceptSelected)=selectConcept($event)></pub-result-view-wrapper>
</div>
